/**
 * @param {产地数据列表} productionPlaces
 */
function productionPlaceDatas2List(productionPlaces) {
  let htmlText = '';
  productionPlaces.forEach(element => {
    htmlText += (productionPlaceData2Cell(element));
  });
  return htmlText;
}
function productionPlaceData2Cell(place) {
  let htmlText = '<div class="production-place-item">';
  htmlText += (
    '<a href="/area/' + place.id + '/' + (place.name || (place.privince || '')) + '"><div>' +
    '<img src="' + place.picUrl + '" />' +
    '</div></a>'
  );
  htmlText += (
    '<div class="place-name">' +
    '<span>' + place.name + '</span>' +
    '</div>'
  );

  htmlText += ('</div>');
  return htmlText;
}

/**
 * PC 产地甄馆
 */
module.exports = {
  productionPlaceDatas2List
};
